(() => {
    'use strict';

    // Initialize one ResizeObserver for all journey widgets.
    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            redrawLinesTimeoutHandler(entry.target);
        }
    });

    // ResizeObserver can trigger changes very rapidly, so we want to throttle the redrawLines calls.
    // Redraw lines only after 10ms of resize inactivity.
    const redrawLinesTimeoutHandler = widget => {
        widget = $(widget);
        const timeoutId = widget.data('resizeTimeoutId') ?? null;
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
        }
        widget.data('resizeTimeoutId', setTimeout(() => {
            widget.removeData('resizeTimeoutId');
            drawLines(widget);
        }, 10));
    };

    const getCenterPoint = (parent, element) => {
        let parentRect = parent[0].getBoundingClientRect();
        let elementRect = element[0].getBoundingClientRect();
        const paddingTop = parseFloat(element.css('padding-top'));

        return {
            x: elementRect.left + elementRect.width / 2 - parentRect.left + parent.scrollLeft(),
            y: elementRect.top + elementRect.height / 2 - parentRect.top + paddingTop
        };
    };

    const drawLineBetweenCenterPoints = (parent, i, element1, element2) => {
        const center1 = getCenterPoint(parent, element1);
        const center2 = getCenterPoint(parent, element2);

        const line = parent.find('line[data-index=' + i + ']');

        if (!isNaN(center1.y) && !isNaN(center2.y)) {
            line.attr('x1', center1.x).attr('y1', center1.y).attr('x2', center2.x).attr('y2', center2.y);
        }
    };

    const drawLines = widget => {
        const parent = widget.find('.journey');

        if (parent.length === 0) {
            return;
        }

        const images = widget.find('.phase .phase-image');

        if (images.length > 1) {
            images.each(function (i) {
                if (i < images.length - 1) {
                    const $leftDiv = images.eq(i);
                    const $rightDiv = images.eq(i + 1);

                    // ensure div1 is always the left div and div2 is the right div
                    const $div1 = $leftDiv.offset().left < $rightDiv.offset().left ? $leftDiv : $rightDiv;
                    const $div2 = $div1 === $leftDiv ? $rightDiv : $leftDiv;

                    drawLineBetweenCenterPoints(parent, i, $div1, $div2);
                }
            });
        }
    };

    const updatePhaseSelect = (widget) => {
        const phaseSelect = widget.find('select[name="active_phase"]');
        const selectedOption = phaseSelect.val() ?? 0;

        phaseSelect.find('option').remove();

        widget.find('.phase').each(function (i, phase) {
            phase = $(phase);
            const number = i + 1;
            const title = DOMPurify.sanitize(phase.find('input[name="title"]').val());
            const option = $(`<option value="${i}">${number} - ${title}</option>`)
            phaseSelect.append(option);
        });

        if (phaseSelect.find('option[value=' + selectedOption + ']').length > 0) {
            phaseSelect.val(selectedOption);
        } else {
            phaseSelect.val(0);
        }
    };

    const removePhaseImage = (e) => {
        const modal = $(e.target).closest('.modal');
        const phaseImage = modal.data('phase-image');

        loadPhaseImage(modal, phaseImage);
    };

    const loadPhaseImage = (modal, phaseImage, image = null) => {
        const widget = phaseImage.closest('.widget');

        real.ajax.html(howspace.widgets.getUrl(widget) + '/image/' + image, {
            type: 'GET',
            success: (response) => {
                const newPhase = $(response);
                phaseImage.replaceWith(newPhase);
                howspace.components.init(newPhase);

                howspace.components.modal.close(modal);
            },
            error: () => {
                howspace.components.modal.close(modal);
            }
        });
    };

    const addPage = function(phase, page) {
        // add page to phase page select
        const phases = phase.closest('.phases')
        const pageSelect = phase.find('.page-select select');
        const optgroup = pageSelect.find('optgroup').last();
        const option = $('<option value="' + page.id + '">' + page.title + '</option>');
        optgroup.append(option);

        // sort workspace pages
        const options = $(optgroup.find('option').toArray().sort(function(a, b) {
            return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
        }));

        // set sorted pages to every phase page select
        phases.find('.page-select select').each(function() {
            const select = $(this);
            const val = select.val();
            const optgroup = select.find('optgroup').last();
            optgroup.find('option').remove();
            optgroup.append(options.clone());
            select.val(val);
        });

        pageSelect.val(page.id);
    };

    howspace.widgets.journey = {
        initView: widget => {
            // Observe resize in order to redraw lines.
            resizeObserver.observe(widget[0]);
        },
        destroyView: widget => {
            // Unobserve resize.
            resizeObserver.unobserve(widget[0]);
        },
        initEdit: widget => {
            // Phase title
            widget.on('change', 'input[name="title"]', () => {
                updatePhaseSelect(widget);
            });

            // Scheduling
            widget.find('input[name="phase_activity"]').on('change', function () {
                switch ($(this).val()) {
                    case 'scheduled':
                        widget.find('.phase .is-active-begintime-wrapper:hidden').velocity('slideDown', 'fast');
                        break;
                    default:
                        widget.find('.phase .is-active-begintime-wrapper').velocity('slideUp', 'fast');
                        break;
                }
            });

            // Delete phase
            widget.on('click', '.card .delete-btn', e => {
                const card = $(e.target).closest('.card');
                const title = card.find('.card-title');
                const content = card.find('.card-content');

                if (content.is('.expanded')) {
                    title.trigger('click');
                }

                howspace.components.collapse.destroy(title);

                card.addClass('deleted');
            });

            // Restore phase
            widget.on('click', '.card .restore-btn', e => {
                const card = $(e.target).closest('.card');
                const title = card.find('.card-title');

                howspace.components.collapse.init(title);

                card.removeClass('deleted');
            });

            // Add phase
            widget.find('.add-phase-btn').on('click', () => {
                const sortableList = widget.find('.howspace-sortable-list');
                sortableList.find('.card-title.howspace-collapse-initialized').each(function () {
                    howspace.components.collapse.collapse(this, false);
                });
                const newPhase = howspace.components.sortableList.addItem(sortableList);

                // Card ID
                const id = howspace.generateRandomStr(12);
                newPhase.prop('id', 'card-' + id);
                newPhase.find('.card-title').attr('aria-controls', id + '-content');
                newPhase.find('.card-content').attr('id', id + '-content');

                // Phase index
                const index = sortableList.find('.phase').length;
                newPhase.find('.card-title').html(newPhase.find('.card-title').html() + index);
                newPhase.find('.card-header input').val(newPhase.find('.card-header input').val() + index);

                // Scheduling
                if (widget.find('input[name="phase_activity"]:checked').val() === 'scheduled') {
                    newPhase.find('.is-active-begintime-wrapper').show();
                } else {
                    newPhase.find('.is-active-begintime-wrapper').hide();
                }

                // Allow active phase selection
                widget.find('.phase-activity-wrapper:hidden').velocity('slideDown', 'fast');

                // Scroll to the element
                howspace.scroller.scrollToElement(newPhase);

                setTimeout(() => {
                    updatePhaseSelect(widget);
                }, 100);
            });

            // Item moved event
            widget.on(howspace.components.sortableList.ITEM_MOVED, item => {
                let index = 1;
                widget.find('.phase').each(function () {
                    const phase = $(this);
                    const title = phase.find('.card-title');
                    title.html(title.html().trim().replace(/\d+$/, index));
                    index++;
                });
                updatePhaseSelect(widget);
            });

            // Field expanding event.
            const phasesSortableList = widget.find('.howspace-sortable-list');
            phasesSortableList.on(howspace.components.collapse.EXPANDING, (e) => {
                const cardId = $(e.target).closest('.card').prop('id');
                phasesSortableList.find('.card-title.howspace-collapse-initialized').each(function () {
                    if (cardId !== $(this).closest('.card').prop('id')) {
                        howspace.components.collapse.collapse(this);
                    }
                });
            });

            // Add first phase.
            if (widget.find('.phase').length === 0) {
                widget.find('.add-phase-btn').trigger('click');
            }

            // Page created event.
            widget.on(howspace.workspace.page.create.PAGE_CREATED, '.add-page-btn', e => {
                const phase = $(e.currentTarget).closest('.phase');
                const page = e.detail;

                addPage(phase, page);
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.phases = [];
            widget.find('.phase:not(.deleted)').each(function () {
                dataPayload.phases.push(real.form.getDataPayload($(this)));
            });
            return dataPayload;
        },
        initImageModal: (modal, modalOpener) => {
            modal = $(modal);
            modalOpener = $(modalOpener);

            const phaseImage = modalOpener.prev('.phase-image');
            modal.data('phase-image', phaseImage);

            if (!phaseImage.find('input[name="image"]').val()) {
                modal.find('.remove-image-btn').addClass('d-none');
            }

            modal.find('.select-image-btn').on('click', function () {
                loadPhaseImage(modal, phaseImage, $(this).data('image'));
            });

            modal.find('.remove-image-btn').on('click', removePhaseImage);
        },
        initImageEditorModal: (modal, modalOpener) => {
            modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_INITIALIZING, e => {
                real.button.loading($(modal).find('.save-image-button'));
            });

            modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_READY, e => {
                real.button.reset($(modal).find('.save-image-button'));
            });

            modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_SAVE, e => {
                const canvas = e.detail.data;
                const formData = new FormData();
                const token = real.uid();
                formData.append('upload_process_metadata', JSON.stringify({
                    token: token
                }));

                // Wait until the image is stored to S3
                const handleStored = (notification) => {
                    if (notification.object.uploadedfile?.upload_process_metadata?.token === token) {
                        real.events.off('workspace:uploadedfile:stored', handleStored);
                        const parentModal = $(modalOpener).closest('.modal');
                        const phaseImage = parentModal.data('phase-image');
                        loadPhaseImage(modal, phaseImage, notification.object.uploadedfile.id);
                    }
                };
                real.events.on('uploadedfile:stored', handleStored);

                canvas.toBlob(blob => {
                    formData.append('file', blob, 'journey-phase-cropped.png');

                    real.ajax(real.baseUri + '/api/uploadedfiles', {
                        type: 'POST',
                        data: formData,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                    });
                }, 'image/png');
            });
        },
        initCreatePageModal: (modal, modalOpener) => {
            howspace.workspace.page.create.initModal(modal, modalOpener, false);
        }
    };
})();
